// extracted by mini-css-extract-plugin
export default {"main":"goDRiiBsuEuXD3W1NphN","useSkeleton":"GgAalyCT_nMrUn3ge8Q8","common_bganimation":"rXmDbySTHc21xSyZHmwa"};